import BG from './bg11.svg';

export const BackgroundCssString = `left 0 / 227.5px repeat url('${BG}')`;
